// extracted by mini-css-extract-plugin
export default {"card-description":"CardDescription_card-description__vRa9w"};